import React from 'react';

/**
 * iOS-style segmented control for 2+ mutually exclusive options (Run tab, payload editor, etc.).
 * Styling is the app standard — do not one-off duplicate these classes.
 *
 * @see docs/UI_PATTERNS.md
 *
 * @param {string|number} value — active option value (must match an option.value)
 * @param {(v: string|number) => void} onChange
 * @param {{ value: string|number, label: string }[]} options
 * @param {string} [ariaLabel]
 * @param {string} [className]
 */
export default function SegmentedTabGroup({
  value,
  onChange,
  options,
  ariaLabel = 'Tabs',
  className = ''
}) {
  return (
    <div
      className={`inline-flex rounded-lg bg-gray-200/90 p-0.5 gap-0.5 border border-gray-200/80 ${className}`}
      role="tablist"
      aria-label={ariaLabel}
    >
      {options.map((opt) => {
        const selected = value === opt.value;
        return (
          <button
            key={String(opt.value)}
            type="button"
            role="tab"
            aria-selected={selected}
            onClick={() => onChange(opt.value)}
            className={`px-3 py-1 rounded-md text-xs font-semibold uppercase tracking-wide transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-1 ${
              selected
                ? 'bg-white text-gray-900 shadow-sm'
                : 'text-gray-600 hover:text-gray-800'
            }`}
          >
            {opt.label}
          </button>
        );
      })}
    </div>
  );
}
